import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { GenericComponentsModule } from '@helios/generic-components'
import { RawTradeSummaryPanelComponent } from './raw-trade-summary-panel.component'

@NgModule({
  imports: [CommonModule, GenericComponentsModule],
  declarations: [RawTradeSummaryPanelComponent],
  exports: [RawTradeSummaryPanelComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RawTradeSummaryModule {}

export { RawTradeSummaryPanelComponent }
